import "../../../fonts/dna-r/dnar-icons.css";

export const DnarIcon = (props: any) => {
    const iconName = 'dnar-icons dnar-icons-' + (props.name || '').trim();
    const iconSize = () => {
        switch (props.size) {
        case 'xxsm':
            return '12px';
        case 'xsm':
            return '16px';
        case 'sm':
            return '20px';
        case 'md':
            return '24px';
        case 'lg':
            return '32px';
        case 'xlg':
            return '60px';
        default:
          return '32px';
        }
    }

    const iconColor = () => {
        switch (props.color) {
            // Primary colours 
            //Turquoise
            case 'T1':
               return '#025450';
            case 'T2':
                return '##008381';

            // Neutral colours 
            // Text and UI
            case 'Black':
               return '#000000';
            case 'N1':
                return '#414141';
            case 'N2':
                return '#595959';
            case 'N3':
                return '#757575';
            case 'N4':
                return '#949494';
            case 'White':
                return '#FFFFFF';

            // Alert colours
            // Info
            case 'I1':
                return '#0099FF';
            case 'I2':
                return '#4DB8FF';

            // Success
            case 'S1':
                return '#0099FF';
            case 'S2':
                return '#4DB8FF';    
                
            // Warning
            case 'W1':
                return '#F5A623';
            case 'W2':
                return '#F8C165'; 

            // Danger
            case 'D1':
                return '#C53535';
            case 'D2':
                return '#D67272';
                
            //Highlight colours    
            // Magenta
            case 'M1':
                return '#570066';
            case 'M2':
                return '#A0168C';

            // Purple
            case 'P1':
                return '#35237F';
            case 'P2':
                return '#5E50BF';

            // Yellow
            case 'Y1':
                return '#B7591A';
            case 'Y2':
                return '#FF8C00';
            case 'Y3':
                return '#FFD042';

            // Orange
            case 'O1':
                return '#9E043E';
            case 'O2':
                return '#D93923';    

            // Blue
            case 'B1':
                return '#001E82';
            case 'B2':
                return '#006AD2';
                  
            // Green
            case 'G1':
                return '#074F30';
            case 'G2':
                return '#008A00';       

            default:
              return '#595959';
        }
    };

    return <i className={iconName} style={{fontSize: iconSize(), color: iconColor()} }></i>
};